// make a function to short wallet addrres like sdfas...sfda
 function formatAddress(address) {
    if (!address) return '';
    const firstPart = address.slice(0, 6);
    const lastPart = address.slice(-4);
    return `${firstPart}...${lastPart}`;
}
export default formatAddress;